import { motion } from "framer-motion";

const DISCIPLINES = [
  {
    n: "I",
    name: "Hospitality",
    lead: "Hotels · Resorts · Restaurants",
    body:
      "Arrival experiences, guest journeys and public rooms designed to slow the pulse and elongate memory.",
  },
  {
    n: "II",
    name: "Luxury Residential",
    lead: "Private Homes · Villas · Penthouses",
    body:
      "Personal rooms composed from character, ritual and material — quietly detailed, unmistakably yours.",
  },
  {
    n: "III",
    name: "Commercial Interiors",
    lead: "Workplaces · Retail · Wellness",
    body:
      "Environments that hold intent — where craft meets function, and the brand is felt before it is read.",
  },
];

export default function Disciplines() {
  return (
    <section className="bg-stone2/50" data-testid="disciplines-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-36">
        <div className="grid grid-cols-12 gap-6 items-end mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-6">
            <p className="text-[11px] uppercase tracking-[0.3em] text-muteInk mb-4">— Practice</p>
            <h2 className="font-serif text-4xl md:text-6xl leading-[1.02] tracking-tight text-ink">
              Three disciplines.<br />
              <span className="italic text-clay">One point of view.</span>
            </h2>
          </div>
          <div className="col-span-12 md:col-span-4 md:col-start-9 text-ink/70 leading-relaxed">
            End to end — from the first sketch on butter paper to the last brass handle installed. We hold the pencil the whole way.
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 border-t border-borderWarm">
          {DISCIPLINES.map((d, i) => (
            <motion.div
              key={d.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className={`py-12 md:py-16 md:px-10 first:md:pl-0 last:md:pr-0 ${i > 0 ? "md:border-l border-borderWarm" : ""}`}
              data-testid={`discipline-${d.name.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <div className="flex items-center gap-4">
                <span className="chapter-num text-4xl">{d.n}</span>
                <span className="text-[11px] uppercase tracking-[0.24em] text-muteInk">Discipline</span>
              </div>
              <h3 className="font-serif text-3xl md:text-4xl mt-6 text-ink leading-tight">{d.name}</h3>
              <p className="mt-2 text-[12px] uppercase tracking-[0.22em] text-clay">{d.lead}</p>
              <p className="mt-6 text-ink/75 leading-relaxed">{d.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
